module.exports = __webpack_public_path__ + "static/media/web_image_edit.43afd530.jpg";